export const API_KEY = {
    GET_ROLE: "v1/role/getrole",
    GET: `v1/page/rolepage`,
    POST: "v1/page/rolepage",
    PUT: "v1/page/rolepage",
    DELETE_ROLE_PAGE:(id:number)=>`v1/page/rolepage/${id}`
}